import React from 'react';
import { BookOpenIcon, CalendarDaysIcon, LeafIcon, PenLineIcon } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
import { DecorativeDandelions } from './DecorativeDandelions';
const bonuses = [{
  icon: LeafIcon,
  number: '01',
  title: 'EL BOTIQUÍN HERBOLARIO ARGENTINO',
  subtitle: 'Fichas técnicas de 9 plantas medicinales nativas con principios activos, dosis y preparación. Tu respaldo profesional al momento de orientar a tus pacientes.',
  result: 'Recomendá plantas con fundamento y seguridad profesional',
  value: '$47.000'
}, {
  icon: CalendarDaysIcon,
  number: '02',
  title: 'PROTOCOLO 21 DÍAS: HOJA DE RUTA DIARIA',
  subtitle: 'Calendario y checklist diario en 3 fases para que tu consultante sepa exactamente qué hacer cada día. Incluye registro de síntomas para que vuelva a la sesión con datos concretos.',
  result: 'Tu paciente avanza entre sesiones y vos hacés seguimiento real',
  value: '$67.000'
}, {
  icon: PenLineIcon,
  number: '03',
  title: 'EL HÍGADO EMOCIONAL: GUÍA DE GESTIÓN',
  subtitle: 'Ejercicios de respiración, escritura terapéutica y liberación emocional para trabajar la conexión entre el estrés, la ira contenida y los síntomas físicos del hígado.',
  result: 'Integrá el abordaje emocional del hígado en tu corriente terapéutica',
  value: '$37.000'
}];
const included = ['Anatomía funcional y fisiopatología del hígado graso', 'Bioquímica de la detoxificación explicada de forma accesible', 'El hígado psicosomático: estrés, cortisol e ira contenida', 'Farmacopea completa de plantas nativas argentinas', 'Nutrición funcional y alimentos hepatoprotectores', 'Guía clínica exclusiva: semiología visual de lengua, ojos y piel', 'Recetario hepatoprotector con 30 preparaciones', 'Protocolo de mantenimiento y salud metabólica a largo plazo'];
export function MethodOverview() {
  return <Section id="method" className="max-w-6xl" data-id="element-204" data-mp="338vohfqvn4at">
      <DecorativeDandelions className="-left-36 top-1/3 hidden h-64 w-48 lg:block" tone="gold" data-id="element-205" data-mp="339njopgkb00k" />
      <header className="mb-10 text-center" data-id="element-206" data-mp="137e9p1tmmxhm">
        <div className="inline-flex items-center gap-2 rounded-full border border-brand-green/25 bg-brand-cream px-4 py-2 text-xs font-bold tracking-[.14em] text-brand-green" data-id="element-207" data-mp="y7jhmuy481uz">
          <LeafIcon className="h-4 w-4" data-id="element-208" data-mp="1cxqtgrtmammp" />
          CÓDIGO HEPÁTICO™
        </div>
        <h2 className="mt-5 font-display text-4xl font-bold text-brand-dark md:text-5xl" data-id="element-209" data-mp="1844ntjlvfj0e">
          1 Ebook Principal + 3 Bonus
        </h2>
        <p className="mt-3 text-brand-muted" data-id="element-210" data-mp="1hvirm3kuv4zc">
          El sistema completo para integrar la salud hepática en tu práctica
          terapéutica.
        </p>
      </header>
      <article className="glass-panel mx-auto max-w-5xl rounded-3xl border-brand-green/20 p-6 md:p-9" data-id="element-211" data-mp="1vuifva4ghhuz">
        <div className="flex flex-col gap-6 md:flex-row" data-id="element-212" data-mp="1qu471pv163vw">
          <div className="mx-auto w-32 shrink-0 overflow-hidden rounded-xl border border-brand-yellow/60 bg-brand-surfaceLight shadow-md md:mx-0 md:w-40" data-id="element-213" data-mp="1ibuxjlrfmph">
            <img src="https://cdn.magicpatterns.com/uploads/jWL1fuerYMnax4FueGZ9FR/ChatGPT_Image_16_jul_2026,_02_51_51_p.m..png" alt="Portada de El Gran Libro de la Reparación Hepática" className="h-auto w-full object-cover" draggable={false} data-id="element-214" data-mp="3spwn1kz7gvdy" />
          </div>
          <div data-id="element-215" data-mp="1yf6q779g52x6">
            <p className="text-xs font-bold tracking-[.16em] text-brand-green" data-id="element-216" data-mp="1yfg8e8o925sb">
              EBOOK PRINCIPAL
            </p>
            <h3 className="mt-2 font-serif text-2xl font-bold text-brand-dark md:text-3xl" data-id="element-217" data-mp="1pf1jz0fzoakl">
              El Gran Libro de la Reparación Hepática
            </h3>
            <p className="mt-2 font-semibold text-brand-green" data-id="element-218" data-mp="1ufpg20j2rhlo">
              Ciencia funcional + Fitoterapia + Gestión emocional
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-text" data-id="element-219" data-mp="1kfou06ttmnds">
              El manual técnico-holístico central que te da el marco clínico,
              emocional y práctico para acompañar a tus consultantes en su
              proceso de sanación hepática desde cualquier corriente
              terapéutica.
            </p>
            <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-3 text-sm text-brand-text md:grid-cols-2" data-id="element-220" data-mp="1eqf9d412itfb">
              {included.map(item => <p key={item} className="flex gap-2" data-id="element-221" data-mp="1ao0m87qd97i8">
                  <span className="font-bold text-brand-green" data-id="element-222" data-mp="15pz71xw29sc1">✓</span>
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </article>
      <div className="mt-12 text-center" data-id="element-223" data-mp="vsm6u2ucwlig">
        <h3 className="font-display text-3xl font-bold text-brand-dark" data-id="element-224" data-mp="vufd3h1253px">
          3 bonus incluidos
        </h3>
        <p className="mt-1 text-xs font-bold tracking-[.16em] text-brand-yellow" data-id="element-225" data-mp="r0unoddj5i2c">
          SIEMPRE INCLUIDOS
        </p>
      </div>
      <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-226" data-mp="i1pp571yxoq6">
        {bonuses.map(({
        icon: Icon,
        number,
        title,
        subtitle,
        result,
        value
      }) => <article key={number} className="glass-panel relative flex min-h-[320px] flex-col overflow-hidden rounded-2xl border-brand-green/20 p-6" data-id="element-227" data-mp="839vawbk41cz">
              <span className="absolute left-5 top-4 rounded-md bg-brand-surfaceLight px-2 py-1 text-xs font-bold text-brand-green" data-id="element-228" data-mp="3u3xurtq77g1q">
                {number}
              </span>
              <span className="absolute right-0 top-0 rounded-bl-xl bg-brand-yellow px-3 py-1 text-xs font-bold text-brand-deep" data-id="element-229" data-mp="7x97c84xhxjq">
                GRATIS
              </span>
              <Icon className="mb-5 mt-8 h-8 w-8 text-brand-green" data-id="element-230" data-mp="3behrwzr1jbi5" />
              <h4 className="font-serif text-lg font-bold leading-tight text-brand-dark" data-id="element-231" data-mp="3bc507uvhdmrw">
                BONUS {Number(number)} — {title}
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-brand-muted" data-id="element-232" data-mp="3lbe177ork1nr">
                {subtitle}
              </p>
              <p className="mt-4 text-sm font-semibold text-brand-green" data-id="element-233" data-mp="3q4ox4ds1ey0w">
                ✓ {result}
              </p>
              <p className="mt-auto pt-5 text-sm" data-id="element-234" data-mp="2slnjypru4jnf">
                <span className="text-brand-muted line-through" data-id="element-235" data-mp="2xm1lrq2uexd0">{value}</span>
                <span className="ml-2 font-bold text-brand-green" data-id="element-236" data-mp="2plvkazg00xw7">
                  → GRATIS
                </span>
              </p>
            </article>)}
      </div>
      <ValueSummary data-id="element-237" data-mp="2kkzh6o3h1fru" />
      <Pricing data-id="element-238" data-mp="2zbyjxihmla3i" />
    </Section>;
}
function ValueSummary() {
  return <div className="mx-auto mt-10 max-w-xl overflow-hidden rounded-2xl border border-brand-green/20 bg-brand-cream text-center shadow-sm" data-id="element-239" data-mp="2zb6p49vurgea">
      <div className="px-5 py-4" data-id="element-240" data-mp="26n13zm0vzpdx">
        <p className="text-xs font-bold tracking-[.12em] text-brand-green" data-id="element-241" data-mp="26oc5tgarun2e">
          VALOR TOTAL DEL PACK
        </p>
        <p className="mt-1 text-sm font-semibold text-brand-muted line-through" data-id="element-242" data-mp="21pr6rk79a9fj">
          $348.000 ARS
        </p>
      </div>
      <div className="flex flex-col items-center justify-center gap-1 px-5 py-4 text-brand-cream sm:flex-row sm:gap-3 bg-[#2F8039]" data-id="element-243" data-mp="2gj464rvqno0v">
        <span className="text-xs font-bold tracking-[.12em]" data-id="element-244" data-mp="3rzufukzdexz8">Precio especial de lanzamiento</span>
        <span className="font-display text-3xl font-bold text-[#E1D4A9]" data-id="element-245" data-mp="3n22g54shi7kh">
          $20.990
        </span>
        <span className="font-semibold text-brand-cream/80 text-[10px]" data-id="element-246" data-mp="3uksd1wu40a2w">
          Acceso completo por única vez
        </span>
      </div>
    </div>;
}